const MAIN_JS_HASH_PATTERN = /main\.([a-f0-9]+)\.js/;

export function extractMainJsHash(pathOrUrl) {
  if (!pathOrUrl) return null;
  const match = String(pathOrUrl).match(MAIN_JS_HASH_PATTERN);
  return match ? match[1] : null;
}

export function getLoadedMainJsHash() {
  const scripts = document.querySelectorAll("script[src]");
  for (const script of scripts) {
    const hash = extractMainJsHash(script.src);
    if (hash) return hash;
  }
  return null;
}

export async function fetchDeployedMainJsHash() {
  const response = await fetch(`/asset-manifest.json?t=${Date.now()}`, {
    cache: "no-store",
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch asset manifest (${response.status})`);
  }

  const manifest = await response.json();
  return extractMainJsHash(manifest?.files?.["main.js"]);
}
